var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3955 5.35778C15.2118 -0.702593 24.0988 -0.702593 27.915 5.35778L37.751 20.9779C41.8093 27.4231 37.1444 35.7863 29.4913 35.7863H9.81941C2.16607 35.7863 -2.49883 27.4231 1.5597 20.9779L11.3955 5.35778Z",
    fill: "#44C676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5454 35.7863H9.77797C2.15713 35.7863 -2.48796 27.4572 1.55334 21.0383C1.56548 21.0448 1.57606 21.0504 1.58507 21.0552L13.5454 35.7863Z",
    fill: "#45B872"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7193 35.7863H29.5569C29.604 35.7527 20.3354 30.8376 1.74658 21.0383L13.7193 35.7863Z",
    fill: "#68DE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2905 19.6232C19.259 15.6539 15.642 10.8915 11.4395 5.33601C15.2499 -0.695338 24.1231 -0.695338 27.9333 5.33601L37.7541 20.8814C40.9154 25.8857 38.7757 32.0517 34.0533 34.5208C33.8697 34.6167 29.9489 29.6508 22.2905 19.6232Z",
    fill: "#45B872"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo_no_text.bc5e19ee.svg";
export { ForwardRef as ReactComponent };